import { Sparkles } from "lucide-react";

export function MarketplaceHeader({ status, trialDaysLeft, totalMonthly }) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-4xl font-bold uppercase tracking-tight" data-testid="marketplace-title">
          MERCADO
        </h1>
        <p className="text-muted-foreground mt-1">
          Serviços adicionais para potencializar o seu restaurante
        </p>
      </div>

      <div className="flex items-center gap-4 flex-wrap">
        {status === "trial" && trialDaysLeft > 0 && (
          <div className="flex items-center gap-2 px-4 py-2 bg-blue-50 rounded-xl border border-blue-200">
            <Sparkles className="w-4 h-4 text-blue-600" />
            <span className="text-sm text-blue-700 font-medium">
              Trial: {trialDaysLeft} dias restantes
            </span>
          </div>
        )}

        {totalMonthly > 0 && (
          <div className="flex items-center gap-2 px-4 py-2 bg-purple-50 rounded-xl border border-purple-200">
            <span className="text-sm text-purple-700">
              Módulos: <strong>€{totalMonthly.toFixed(2)}/mês</strong>
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
